import React, { useMemo } from "react";
import { View } from "react-native";
import { useI18nMessage } from "@lookiero/i18n-react";
import { QuestionProjection, useAnswersForQuestion } from "@lookiero/sty-psp-quiz-style-profile-common-ui";
import { Text } from "@lookiero/sty-psp-ui";
import { NextBestActionType } from "../../../../../../projection/nextBestActionDefinition/nextBestActionDefinition";
import { NextBestActionItem } from "../../../../components/nextBestActionItem/NextBestActionItem";
import { DOMAIN } from "../../../../i18n/i18n";
import { useNextBestActionAnswers } from "../../behaviours/useNextBestActionAnswers";
import { style as nextBestActionHostTextStyle } from "./NextBestActionHostText.style";

const NextBestActionHostText: NextBestActionItem<NextBestActionType.HOST_TEXT> = ({ action, segment, country }) => {
  const style = useMemo(() => nextBestActionHostTextStyle(), []);

  const title = useI18nMessage({
    domain: DOMAIN,
    id: action.translationKey,
  });

  const { answers } = useAnswersForQuestion({ question: action as unknown as QuestionProjection });
  const answer = useNextBestActionAnswers({ action, answers, country, segment });

  return (
    <View style={style.container} testID="next-best-action-host-text">
      <Text level={2} style={style.title} variant="detail">
        {title}
      </Text>

      <Text level={2} variant="detailBold">
        {answer}
      </Text>
    </View>
  );
};

export { NextBestActionHostText };
